/**
 * The categories the create flow groups by: **kinds of structure**, never subjects.
 *
 * A template is a shape to think in — a hierarchy, a sequence, a comparison, a network — and a
 * catalogue sorted by subject ("Travel", "Food") filled up with the same tree wearing different
 * words. Sorted by structure, every card on a shelf is a different picture, and a person who
 * needs a timeline finds one whether it is for a trip or for a product launch.
 *
 * Fixed rather than free text: they are a navigation structure. The exhaustive
 * `TEMPLATE_CATEGORY_LABELS` below makes forgetting to name one a compile error.
 */
export const TEMPLATE_CATEGORIES = [
    'ideas',
    'hierarchy',
    'process',
    'compare',
    'networks',
    'data',
];
/** The shelf names in English. `TEMPLATE_CATEGORY_LABELS_PT` has the Portuguese ones. */
export const TEMPLATE_CATEGORY_LABELS = {
    ideas: 'Ideas',
    hierarchy: 'Hierarchy',
    process: 'Process & time',
    compare: 'Compare & decide',
    networks: 'Networks & maps',
    data: 'Data',
};
export const TEMPLATE_CATEGORY_LABELS_PT = {
    ideas: 'Ideias',
    hierarchy: 'Hierarquia',
    process: 'Processo e tempo',
    compare: 'Comparar e decidir',
    networks: 'Redes e mapas',
    data: 'Dados',
};
//# sourceMappingURL=types.js.map